import React, { Component } from 'react'
import {
    Button,
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    Spinner,
} from 'reactstrap'
import { connect } from 'react-redux'
import { AvForm, AvField } from 'availity-reactstrap-validation'
import { registerUser } from '../redux/user/actions'
import logo from '../assets/img/logo-white.svg'
import { NavLink } from 'react-router-dom'
import {
    sendForgotPasswordToken,
    forgotPasswordFinalStep,
} from '../redux/auth/actions'
import { withTranslate } from 'react-redux-multilingual'
import informationIcon from '../assets/img/navbarIcons/information.svg'

class ForgotPassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            image: '',
            mobile: '',
            token: '',
            password: '',
        }
    }

    handleSubmit = (event, errors, values) => {
        event.preventDefault()
        event.persist()
        this.setState({ errors, values })

        if (errors.length == 0)
            this.props.sendForgotPasswordToken(this.state.mobile)
    }

    handleSecondStepSubmit = (event, errors, values) => {
        event.preventDefault()
        event.persist()
        this.setState({ errors, values })

        if (errors.length == 0)
            this.props.forgotPasswordFinalStep(
                this.state.mobile,
                this.state.token,
                this.state.password
            )
    }

    handleInputChange = (e) => {
        const name = e.target.name
        this.setState({ [name]: e.target.value })
    }

    getErrors = () => {
        if (!this.props.error) return ''

        if (typeof this.props.error == 'object') {
            let messages = []
            for (const key in this.props.error) {
                messages.push(<p>{this.props.error[key]}</p>)
            }
            return messages
        }
        return this.props.error.toString()
    }

    render = () => {
        return (
            <React.Fragment>
                <div className="text-center mt-4 mb-4">
                    <img
                        src={logo}
                        className="img-fluid auth-logo"
                        width="300"
                        alt=""
                    />
                </div>

                <Card className="text-right auth-card">
                    {this.props.error && (
                        <CardHeader className="text-center w-100">
                            <CardTitle className="m-0 text-danger">
                                {this.getErrors()}
                            </CardTitle>
                        </CardHeader>
                    )}
                    <CardBody>
                        <div className="m-sm-1">
                            {!this.props.isForgotPasswordTokenSent ? (
                                <AvForm onSubmit={this.handleSubmit}>
                                    <AvField
                                        onChange={this.handleInputChange}
                                        name="mobile"
                                        autoComplete="username"
                                        bsSize="lg"
                                        label="موبایل "
                                        type="text"
                                        placeholder="شماره موبایل"
                                        validate={{
                                            required: {
                                                value: true,
                                                errorMessage: this.props.translate(
                                                    'requiredField'
                                                ),
                                            },
                                            pattern: {
                                                value: /^[\d٠-٩۰-۹]{11}$/,
                                                errorMessage: this.props.translate(
                                                    'invalidMobileFormat'
                                                ),
                                            },
                                        }}
                                    />

                                    <div className="mt-3 d-flex justify-content-between align-items-center">
                                        <NavLink to="/signup" className="register-link">
                                            {this.props.translate('notRegisteredYet')}
                                        </NavLink>
                                        {!this.props.waiting ? (
                                            <Button
                                                type="submit"
                                                color="primary"
                                                size="lg"
                                                className="forgot-password-btn"
                                            >
                                                ارسال کد
                                            </Button>
                                        ) : (
                                            <Spinner />
                                        )}
                                    </div>
                                </AvForm>
                            ) : (
                                <AvForm onSubmit={this.handleSecondStepSubmit}>
                                    <AvField
                                        onChange={this.handleInputChange}
                                        name="token"
                                        autoComplete="one-time-code"
                                        value={this.state.token}
                                        bsSize="lg"
                                        label="کد دریافتی"
                                        placeholder="کد دریافتی"
                                        type="text"
                                        validate={{
                                            required: {
                                                value: true,
                                                errorMessage: this.props.translate(
                                                    'requiredField'
                                                ),
                                            },
                                        }}
                                    />
                                    <AvField
                                        onChange={this.handleInputChange}
                                        name="password"
                                        autoComplete="new-password"
                                        bsSize="lg"
                                        label="رمز عبور جدید"
                                        placeholder="رمز عبور جدید"
                                        type="password"
                                        validate={{
                                            required: {
                                                value: true,
                                                errorMessage: 'فیلد الزامی است',
                                            },
                                            minLength: {
                                                value: 8,
                                                errorMessage: this.props.translate(
                                                    'passwordMinLength'
                                                ),
                                            },
                                        }}
                                    />

                                    <div className="mt-3 d-flex justify-content-between align-items-center">
                                        <NavLink to="/signup" className="register-link">
                                            {this.props.translate('notRegisteredYet')}
                                        </NavLink>
                                        {!this.props.waiting ? (
                                            <Button
                                                type="submit"
                                                color="primary"
                                                size="lg"
                                                className="forgot-password-btn"
                                            >
                                                تغییر رمز عبور
                                            </Button>
                                        ) : (
                                            <Spinner />
                                        )}
                                    </div>
                                </AvForm>
                            )}
                        </div>
                        <hr />
                        <hr className="solid"/>
                        <Button
                            color="primary"
                            size="lg"
                            className="help-btn"
                        >
                            <img src={informationIcon}/>
                            {this.props.translate('help')}
                        </Button>
                    </CardBody>
                </Card>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        waiting: store.auth.waiting,
        error: store.auth.error,
        isForgotPasswordTokenSent: store.auth.isForgotPasswordTokenSent,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        sendForgotPasswordToken: (mobile) =>
            dispatch(sendForgotPasswordToken(mobile)),
        forgotPasswordFinalStep: (mobile, token, password) =>
            dispatch(forgotPasswordFinalStep(mobile, token, password)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslate(ForgotPassword))
